import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import TelegramBingoGenerator from './TelegramBingoGenerator';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TelegramBingoGenerator />
  </React.StrictMode>
);